import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12, default as _styled13, default as _styled14, default as _styled15, default as _styled16, default as _styled17, default as _styled18, default as _styled19, default as _styled20, default as _styled21, default as _styled22, default as _styled23, default as _styled24, default as _styled25, default as _styled26, default as _styled27 } from "styled-components";
import React from "react";
import { gsap } from "gsap";
import { AnimatePresence, m } from "framer-motion";
import type { Mode } from "~/features/ui/get-theme-style";
import { Wrap } from "~/features/ui/wrap";
import { Headline } from "~/features/ui/headline";
import { Button } from "~/features/ui/button";
import { Slider } from "~/features/ui/slider";
import { Icon } from "~/features/ui/icon";
import { Media } from "~/features/ui/media";
import { Link } from "~/features/ui/link";
import { isLinkValid } from "~/features/ui/link/utils";
import { takeFirst } from "~/features/app/utils";
import { cleanStegaForTextTransform } from "~/features/sanity/stega";
import CaretLeft from "~/public/icons/caret-left.svg";
import CaretRight from "~/public/icons/caret-right.svg";
import { Section, CardProgressOverlay, SvgLogo, type PartnerGalleryLayoutProps } from "./shared";
import { usePartnerGallery } from "./use-partner-gallery";
export function PartnerGalleryMobileView({
  anchor,
  items,
  mode,
  hasTopDivider,
  isHighlighted,
  sectionProps,
  showGalleryNavigation
}: PartnerGalleryLayoutProps) {
  const {
    activeIndex,
    sliderRef,
    cardContentRef,
    mediaContainerRef,
    changeSlide,
    handleAutoAdvance,
    handleSliderMounted,
    handleSliderMove,
    handleSliderResized
  } = usePartnerGallery(items.length);
  const [isExpanded, setIsExpanded] = React.useState(false);
  const accordionRef = React.useRef<HTMLDivElement>(null);
  const toggleAccordion = React.useCallback(() => {
    const el = accordionRef.current;
    if (!el) return;
    if (isExpanded) {
      setIsExpanded(false);
      gsap.to(el, {
        height: 0,
        opacity: 0,
        duration: 0.4,
        ease: "power2.inOut"
      });
    } else {
      setIsExpanded(true);
      gsap.set(el, {
        height: "auto",
        opacity: 1
      });
      const fullHeight = el.scrollHeight;
      gsap.fromTo(el, {
        height: 0,
        opacity: 0
      }, {
        height: fullHeight,
        opacity: 1,
        duration: 0.4,
        ease: "power2.inOut",
        clearProps: "height"
      });
    }
  }, [isExpanded]);
  const activeItem = items[activeIndex];
  const activeLogo = activeItem?.logo;
  const activeLink = takeFirst(activeItem?.link);
  return <_StyledSection {...sectionProps} data-theme={mode as Mode} id={takeFirst(anchor)?.id || undefined} data-anchor-name={takeFirst(anchor)?.name || undefined} $_css={[{
    "position": "relative",
    "@media (min-width: 1024px)": {
      "display": "none"
    }
  }, isHighlighted ? {
    "backgroundColor": "var(--white-static)",
    "color": "var(--black-static)"
  } : {
    "backgroundColor": "var(--bg-secondary)",
    "color": "var(--text-primary)"
  }]}>
      <_StyledWrap>
        <_StyledDiv $_css2={[{
        "position": "relative"
      }]}>
          <_StyledDiv2 ref={mediaContainerRef} $_css3={[{
          "position": "relative",
          "height": "69rem",
          "overflow": "hidden",
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(69 69 69 / var(--tw-bg-opacity))"
        }]}>
            {items.map((item, idx) => {
            const media = item.media;
            return <_StyledDiv3 key={idx} data-media-idx={idx} style={{
              opacity: idx === activeIndex ? 1 : 0,
              transition: "opacity 1000ms cubic-bezier(0.4, 0, 0.2, 1)"
            }} $_css4={[{
              "position": "absolute",
              "inset": "0",
              "overflow": "hidden"
            }]}>
                  {media && <_StyledDiv4 data-zoom $_css5={[{
                "position": "relative",
                "height": "100%",
                "width": "100%"
              }]}>
                      <Media {...media} imageProps={{
                  fit: "cover",
                  rounded: false,
                  loading: idx === 0 ? "eager" : "lazy"
                }} />
                      <AnimatePresence>
                        {isExpanded && <_StyledMDiv initial={{
                    opacity: 0,
                    backdropFilter: "blur(0px)"
                  }} animate={{
                    opacity: 1,
                    backdropFilter: "blur(10px)"
                  }} exit={{
                    opacity: 0,
                    backdropFilter: "blur(0px)"
                  }} $_css6={[{
                    "position": "absolute",
                    "inset": "0",
                    "backgroundColor": "rgba(0, 7, 4, 0.2)"
                  }]} />}
                      </AnimatePresence>
                    </_StyledDiv4>}
                </_StyledDiv3>;
          })}

            <_StyledDiv5 ref={cardContentRef} $_css7={[{
            "position": "relative",
            "zIndex": "10",
            "display": "flex",
            "height": "100%",
            "flexDirection": "column",
            "justifyContent": "flex-end",
            "backgroundColor": "rgba(0, 7, 4, 0.2)",
            "padding": "var(--spacing-lg)",
            "--tw-text-opacity": "1",
            "color": "rgb(255 255 255 / var(--tw-text-opacity))"
          }]}>
              <_StyledButton type="button" aria-label={isExpanded ? "Collapse details" : "Expand details"} aria-expanded={isExpanded} onClick={toggleAccordion} data-animate="logo" $_css8={[{
              "display": "flex",
              "width": "100%",
              "alignItems": "center",
              "justifyContent": "space-between"
            }]}>
                {activeLogo?.url && <_StyledSvgLogo src={activeLogo.url} alt={activeLogo.alt ?? ""} tone="light" position="left center" />}
                <_StyledSpan $_css9={[{
                "position": "relative",
                "display": "flex",
                "height": "4rem",
                "width": "4rem",
                "alignItems": "center",
                "justifyContent": "center",
                "borderRadius": "2px",
                "--tw-bg-opacity": "1",
                "backgroundColor": "rgb(108 112 97 / var(--tw-bg-opacity))"
              }]}>
                  <_StyledSpan2 style={{
                  width: 6,
                  height: 1
                }} $_css10={[{
                  "position": "absolute",
                  "backgroundColor": "currentColor"
                }]} />
                  <_StyledSpan3 style={{
                  width: 6,
                  height: 1,
                  transform: isExpanded ? "rotate(0deg)" : "rotate(90deg)"
                }} $_css11={[{
                  "position": "absolute",
                  "backgroundColor": "currentColor",
                  "transitionProperty": "transform",
                  "transitionDuration": "250ms",
                  "transitionTimingFunction": "ease-in-out"
                }]} />
                </_StyledSpan>
              </_StyledButton>

              <_StyledDiv6 ref={accordionRef} style={{
              height: 0,
              opacity: 0
            }} $_css12={[{
              "overflow": "hidden"
            }]}>
                <_StyledDiv7 key={activeIndex} $_css13={[{
                "display": "flex",
                "flexDirection": "column",
                "alignItems": "flex-start",
                "gap": "var(--spacing-lg)",
                "paddingTop": "var(--spacing-xl)"
              }]}>
                  {activeItem?.title && <_StyledDiv8 data-animate="title" $_css14={[{
                  "overflow": "hidden"
                }]}>
                      <_StyledHeadline type="h2" text={cleanStegaForTextTransform(activeItem.title)} />
                    </_StyledDiv8>}
                  {activeItem?.description && <_StyledDiv9 data-animate="description">
                      {activeItem.description}
                    </_StyledDiv9>}
                  {isLinkValid(activeLink) && <div data-animate="cta">
                      <Button as={Link} {...activeLink} variant="underline" />
                    </div>}
                </_StyledDiv7>
              </_StyledDiv6>
            </_StyledDiv5>

            {!showGalleryNavigation && <_StyledDiv10 $_css15={[{
            "position": "absolute",
            "right": "var(--spacing-sm)",
            "top": "var(--spacing-sm)",
            "zIndex": "10",
            "display": "flex",
            "overflow": "hidden",
            "borderRadius": "4px",
            "borderWidth": "1px",
            "borderColor": "var(--stroke-primary)"
          }]}>
                <_StyledButton2 type="button" aria-label="Previous slide" onClick={() => changeSlide(activeIndex > 0 ? activeIndex - 1 : items.length - 1)} $_css16={[{
              "display": "flex",
              "height": "3.2rem",
              "width": "3.2rem",
              "alignItems": "center",
              "justifyContent": "center",
              "backgroundColor": "rgba(0, 7, 4, 0.2)",
              "--tw-text-opacity": "1",
              "color": "rgb(255 255 255 / var(--tw-text-opacity))",
              "--tw-backdrop-blur": "blur(16px)",
              "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)"
            }]}>
                  <Icon icon={CaretLeft} size="16" aria-hidden />
                </_StyledButton2>
                <_StyledButton3 type="button" aria-label="Next slide" onClick={() => changeSlide(activeIndex < items.length - 1 ? activeIndex + 1 : 0)} $_css17={[{
              "display": "flex",
              "height": "3.2rem",
              "width": "3.2rem",
              "alignItems": "center",
              "justifyContent": "center",
              "backgroundColor": "rgba(0, 7, 4, 0.2)",
              "--tw-text-opacity": "1",
              "color": "rgb(255 255 255 / var(--tw-text-opacity))",
              "--tw-backdrop-blur": "blur(16px)",
              "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)"
            }]}>
                  <Icon icon={CaretRight} size="16" aria-hidden />
                </_StyledButton3>
              </_StyledDiv10>}
          </_StyledDiv2>

          {showGalleryNavigation && <_StyledDiv11 $_css18={[{
          "position": "absolute",
          "left": "0",
          "right": "0",
          "top": "2.4rem",
          "zIndex": "10",
          "marginLeft": "auto",
          "marginRight": "auto",
          "width": "100%",
          "maxWidth": "calc(100% - 4.8rem)",
          "overflow": "hidden",
          "borderRadius": "4px",
          "backgroundColor": "rgba(0, 7, 4, 0.2)",
          "padding": "var(--spacing-xs)",
          "--tw-backdrop-blur": "blur(16px)",
          "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)"
        }, hasTopDivider && {
          "borderTopWidth": "1px",
          "borderColor": "var(--stroke-primary)"
        }]}>
              <Slider ref={sliderRef} onMounted={handleSliderMounted} onMove={handleSliderMove} onResized={handleSliderResized} options={{
            perPage: 3,
            perMove: 1,
            gap: 5
          }}>
                {items.map((item, idx) => {
              const logo = item.logo;
              const media = item.media;
              return <Slider.Slide key={idx} onClick={() => changeSlide(idx)}>
                      <_StyledDiv12 $_css19={[{
                  "position": "relative",
                  "display": "flex",
                  "height": "4.8rem",
                  "cursor": "pointer",
                  "alignItems": "center",
                  "justifyContent": "center",
                  "overflow": "hidden",
                  "borderRadius": "4px",
                  "--tw-bg-opacity": "1",
                  "backgroundColor": "rgb(0 7 4 / var(--tw-bg-opacity))",
                  "padding": "var(--spacing-md)",
                  "--tw-text-opacity": "1",
                  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
                }]}>
                        {media ? <_StyledDiv13 style={{
                    opacity: idx === activeIndex ? 0.4 : 0
                  }} $_css20={[{
                    "position": "absolute",
                    "inset": "0",
                    "transitionProperty": "opacity",
                    "transitionDuration": "500ms"
                  }]}>
                            <Media {...media} imageProps={{
                      fit: "cover",
                      rounded: false,
                      loading: "lazy"
                    }} />
                          </_StyledDiv13> : <_StyledDiv14 $_css21={[{
                    "position": "absolute",
                    "inset": "0",
                    "--tw-bg-opacity": "1",
                    "backgroundColor": "rgb(0 7 4 / var(--tw-bg-opacity))"
                  }]} />}
                        <_StyledDiv15 style={{
                    opacity: idx === activeIndex ? 0 : 1
                  }} $_css22={[{
                    "position": "absolute",
                    "inset": "0",
                    "--tw-bg-opacity": "1",
                    "backgroundColor": "rgb(0 7 4 / var(--tw-bg-opacity))",
                    "transitionProperty": "opacity",
                    "transitionDuration": "500ms"
                  }]} />
                        {idx === activeIndex && <CardProgressOverlay key={activeIndex} onComplete={handleAutoAdvance} />}
                        {logo?.url && <_StyledSvgLogo2 src={logo.url} alt={logo.alt ?? ""} tone="light" position="center" $_css23={[{
                    "height": "1.2rem",
                    "maxWidth": "4.8rem"
                  }, {
                    "position": "relative",
                    "zIndex": "10"
                  }, idx === activeIndex ? {
                    "opacity": "1"
                  } : {
                    "opacity": "0.3"
                  }]} />}
                      </_StyledDiv12>
                    </Slider.Slide>;
            })}
              </Slider>
            </_StyledDiv11>}
        </_StyledDiv>
      </_StyledWrap>
    </_StyledSection>;
}
var _StyledSection = /*#__PURE__*/_styled(Section).withConfig({
  componentId: "sc-sf-p4p3c5-0"
})`${p => p.$_css}`;
var _StyledWrap = _styled2(Wrap).withConfig({
  componentId: "sc-sf-p4p3c5-1"
})({
  "borderWidth": "0px"
});
var _StyledDiv = _styled3("div").withConfig({
  componentId: "sc-sf-p4p3c5-2"
})`${p => p.$_css2}`;
var _StyledDiv2 = _styled4("div").withConfig({
  componentId: "sc-sf-p4p3c5-3"
})`${p => p.$_css3}`;
var _StyledDiv3 = _styled5("div").withConfig({
  componentId: "sc-sf-p4p3c5-4"
})`${p => p.$_css4}`;
var _StyledDiv4 = _styled6("div").withConfig({
  componentId: "sc-sf-p4p3c5-5"
})`${p => p.$_css5}`;
var _StyledMDiv = _styled7(m.div).withConfig({
  componentId: "sc-sf-p4p3c5-6"
})`${p => p.$_css6}`;
var _StyledDiv5 = _styled8("div").withConfig({
  componentId: "sc-sf-p4p3c5-7"
})`${p => p.$_css7}`;
var _StyledButton = _styled9("button").withConfig({
  componentId: "sc-sf-p4p3c5-8"
})`${p => p.$_css8}`;
var _StyledSvgLogo = _styled10(SvgLogo).withConfig({
  componentId: "sc-sf-p4p3c5-9"
})({
  "height": "4.8rem"
});
var _StyledSpan = _styled11("span").withConfig({
  componentId: "sc-sf-p4p3c5-10"
})`${p => p.$_css9}`;
var _StyledSpan2 = _styled12("span").withConfig({
  componentId: "sc-sf-p4p3c5-11"
})`${p => p.$_css10}`;
var _StyledSpan3 = _styled13("span").withConfig({
  componentId: "sc-sf-p4p3c5-12"
})`${p => p.$_css11}`;
var _StyledDiv6 = _styled14("div").withConfig({
  componentId: "sc-sf-p4p3c5-13"
})`${p => p.$_css12}`;
var _StyledDiv7 = _styled15("div").withConfig({
  componentId: "sc-sf-p4p3c5-14"
})`${p => p.$_css13}`;
var _StyledDiv8 = _styled16("div").withConfig({
  componentId: "sc-sf-p4p3c5-15"
})`${p => p.$_css14}`;
var _StyledHeadline = _styled17(Headline).withConfig({
  componentId: "sc-sf-p4p3c5-16"
})({
  "fontSize": "2rem",
  "lineHeight": "1.3",
  "letterSpacing": "0.02rem",
  "fontWeight": "400"
});
var _StyledDiv9 = _styled18("div").withConfig({
  componentId: "sc-sf-p4p3c5-17"
})({
  "fontSize": "1.6rem",
  "lineHeight": "1.5",
  "fontWeight": "400"
});
var _StyledDiv10 = _styled19("div").withConfig({
  componentId: "sc-sf-p4p3c5-18"
})`${p => p.$_css15}`;
var _StyledButton2 = _styled20("button").withConfig({
  componentId: "sc-sf-p4p3c5-19"
})`${p => p.$_css16}`;
var _StyledButton3 = _styled21("button").withConfig({
  componentId: "sc-sf-p4p3c5-20"
})`${p => p.$_css17}`;
var _StyledDiv11 = _styled22("div").withConfig({
  componentId: "sc-sf-p4p3c5-21"
})`${p => p.$_css18}`;
var _StyledDiv12 = _styled23("div").withConfig({
  componentId: "sc-sf-p4p3c5-22"
})`${p => p.$_css19}`;
var _StyledDiv13 = _styled24("div").withConfig({
  componentId: "sc-sf-p4p3c5-23"
})`${p => p.$_css20}`;
var _StyledDiv14 = _styled25("div").withConfig({
  componentId: "sc-sf-p4p3c5-24"
})`${p => p.$_css21}`;
var _StyledDiv15 = _styled26("div").withConfig({
  componentId: "sc-sf-p4p3c5-25"
})`${p => p.$_css22}`;
var _StyledSvgLogo2 = /*#__PURE__*/_styled27(SvgLogo).withConfig({
  displayName: "mobile___StyledSvgLogo2",
  componentId: "sc-1igtnql-0"
})(["", ""], p => p.$_css23);